import React, { useState } from "react"
import OrderBlock from "../OrderBlock"
import {
  CompanyAttribute,
  Order,
  OrderAddress,
  OrderState
} from "lib/types/generated/graphql-types"
import ModifyAddress from "./ModifyAddress"
import { AddressList } from "./Address.styled"
import { AddressType } from "lib/types/order"
import CustomerHeader from "./CustomerHeader"
import AddressInfo from "./AddressInfo"
import { ModificationAddresses } from "../../../classes/order/OrderModificationAddresses"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"
import { useDispatch } from "react-redux"
import ConfirmPopup from "./ConfirmPopup"
import { Maybe } from "@graphql-tools/utils"

type Props = {
  addressType: AddressType
  address: OrderAddress
  company?: Maybe<CompanyAttribute>
  order: Order
  refetch: () => void
  refetchLoading: boolean
  expandableAddress?: boolean
  showActionButtons?: boolean
}

const Address = ({
  addressType,
  address,
  order,
  refetch,
  refetchLoading,
  company,
  expandableAddress,
  showActionButtons
}: Props) => {
  const [showPopup, setShowPopup] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const dispatch = useDispatch()

  const modificationAddresses = new ModificationAddresses(order?.Modifications)

  const onGoingUpdate = modificationAddresses?.getOngoingModification()?.addresses?.data

  const unsavedAddress = () => {
    if (modificationAddresses.onGoing()) {
      if (!!onGoingUpdate?.shippingAddress && addressType === AddressType.SHIPPING_ADDRESS)
        return true
      return !!onGoingUpdate?.billingAddress && addressType === AddressType.BILLING_ADDRESS
    }
    return false
  }

  const editDisabled =
    (!!onGoingUpdate?.shippingAddress && addressType !== AddressType.SHIPPING_ADDRESS) ||
    (!!onGoingUpdate?.billingAddress && addressType !== AddressType.BILLING_ADDRESS)

  const showEdit = order.status.orderStates[0] !== OrderState.Cancelled

  const handleEditAddressClick = () => {
    if (editDisabled || !showEdit) return
    if (unsavedAddress()) {
      return setShowPopup(true)
    }
    return dispatch(showEditSidebar())
  }

  return (
    <OrderBlock>
      {showEdit && (
        <ModifyAddress
          addressType={addressType}
          address={address}
          orderId={order.id}
          refetch={refetch}
          setShowPopup={setShowPopup}
        />
      )}
      {showPopup && (
        <ConfirmPopup
          setShowPopup={setShowPopup}
          modificationId={modificationAddresses?.getOngoingModification()?.id}
          refetch={refetch}
          refetchLoading={refetchLoading}
          addressType={addressType}
        ></ConfirmPopup>
      )}
      <AddressList>
        <CustomerHeader
          address={address}
          handleEditAddressClick={handleEditAddressClick}
          editDisabled={editDisabled}
          unsavedAddress={unsavedAddress()}
          showEdit={showEdit}
          expandableAddress={expandableAddress}
          setExpanded={setExpanded}
          expanded={expanded}
          showActionButtons={showActionButtons}
        />
        {!expandableAddress ? (
          <AddressInfo address={address} showCustomerInfo={false} company={company} />
        ) : (
          expanded && (
            <AddressInfo
              address={address}
              showCustomerInfo={false}
              company={company}
              expandableAddress={expandableAddress}
              setExpanded={setExpanded}
            />
          )
        )}
      </AddressList>
    </OrderBlock>
  )
}

export default Address
